import { render, staticRenderFns } from "./EmptyTrailerDisplay.vue?vue&type=template&id=a24c4624"
import script from "./EmptyTrailerDisplay.vue?vue&type=script&lang=js"
export * from "./EmptyTrailerDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports